/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { ModerationActionsContainer_story$ref } from "./ModerationActionsContainer_story.graphql";
import { UserBanPopoverContainer_story$ref } from "./UserBanPopoverContainer_story.graphql";
declare const _ModerationDropdownContainer_story$ref: unique symbol;
export type ModerationDropdownContainer_story$ref = typeof _ModerationDropdownContainer_story$ref;
export type ModerationDropdownContainer_story = {
    readonly id: string;
    readonly " $fragmentRefs": ModerationActionsContainer_story$ref & UserBanPopoverContainer_story$ref;
    readonly " $refType": ModerationDropdownContainer_story$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ModerationDropdownContainer_story",
    "type": "Story",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "ModerationActionsContainer_story",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "UserBanPopoverContainer_story",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'db72d8e81425c689aa66ca47fa11d612';
export default node;
